export const MOBILE_STACKED = 'stacked';
export const MOBILE_CAROUSEL = 'carousel';
export const LESS_WHITESPACE = 'lessnbsp';
export const MORE_WHITESPACE = 'morenbsp';
